module.exports = __webpack_public_path__ + "image/select-bg.png";